var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountGreenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 24C5.63 24 0.25 18.62 0.25 12C0.25 5.38 5.63 0 12.25 0C18.87 0 24.25 5.38 24.25 12C24.25 18.62 18.87 24 12.25 24ZM5.62 19.48C7.39 21.05 9.71 22 12.25 22C14.79 22 17.11 21.05 18.88 19.48C18.53 18.84 18.1 18.26 17.58 17.74C14.64 14.8 9.86 14.8 6.92 17.74C6.4 18.26 5.97 18.84 5.62 19.48ZM15.23 14.01C16.61 14.46 17.9 15.23 19 16.33C19.49 16.82 19.92 17.36 20.3 17.94C21.53 16.28 22.26 14.22 22.26 12C22.26 6.49 17.77 2 12.26 2C6.75 2 2.25 6.49 2.25 12C2.25 14.22 2.98 16.28 4.21 17.94C4.58 17.36 5.01 16.82 5.51 16.33C6.6 15.24 7.9 14.46 9.28 14.01C8.05 13.1 7.26 11.64 7.26 10C7.26 7.24 9.5 5 12.26 5C15.02 5 17.26 7.24 17.26 10C17.26 11.64 16.46 13.1 15.24 14.01H15.23ZM12.25 7C10.6 7 9.25 8.35 9.25 10C9.25 11.65 10.6 13 12.25 13C13.9 13 15.25 11.65 15.25 10C15.25 8.35 13.9 7 12.25 7Z",
    fill: "#A32DC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountGreenIcon);
export default __webpack_public_path__ + "static/media/account_green-icon.23bebbff.svg";
export { ForwardRef as ReactComponent };